import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import LogoutIcon from '@mui/icons-material/Logout'
import {
    AppBar as MuiAppBar,
    Toolbar,
    IconButton,
    Avatar,
    Menu,
    MenuItem,
    Typography,
    Box,
    Divider
} from '@mui/material'
import { styled } from '@mui/system'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { acDrawerToggle, acLogout } from '../../../store/actions'
import { heroLightImage } from '../../../assets'

const StyledToolbar = styled(Toolbar)(() => ({
    display: 'flex',
    justifyContent: 'space-between'
}))

const Logo = () => (
    <Box display="flex" alignItems="center" gap={1} sx={{ cursor: 'pointer' }}>
        <img src={heroLightImage} alt="4kst" height={32} onClick={() => {
            window.location.href = '/'
        }} />
    </Box>
)

const MyAppBar = () => {
    const dispatch = useDispatch()
    const drawerOpen = useSelector((state) => state.drawer.isOpen)

    const user = useSelector((state) => state.auth.user)
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)

    const [anchorEl, setAnchorEl] = useState(null)

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const handleLogout = () => {
        dispatch(acLogout())
        setAnchorEl(null)
    }

    const getInitials = (name) => {
        if (!name) return 'U'
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2)
    }

    const getDisplayName = () => {
        if (!user) return 'Usuário'

        if (user.first_name && user.last_name) {
            return `${user.first_name} ${user.last_name}`
        }

        if (user.name) {
            return user.name
        }

        if (user.first_name) {
            return user.first_name
        }

        if (user.username) {
            return user.username
        }

        return 'Usuário'
    }

    const getEmail = () => {
        return user?.email || 'email@exemplo.com'
    }

    if (!isAuthenticated) {
        return (
            <MuiAppBar
                position="fixed"
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backgroundColor: '#002FAD',
                }}
            >
                <StyledToolbar>
                    <Box display="flex" alignItems="center">
                        <IconButton
                            color="inherit"
                            edge="start"
                            onClick={() => dispatch(acDrawerToggle())}
                            sx={{ mr: 2 }}
                        >
                            {drawerOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                        <Logo />
                    </Box>
                </StyledToolbar>
            </MuiAppBar>
        )
    }

    return (
        <MuiAppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: '#002FAD',
            }}
        >
            <StyledToolbar>
                <Box display="flex" alignItems="center">
                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={() => dispatch(acDrawerToggle())}
                        sx={{ mr: 2 }}
                    >
                        {drawerOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                    <Logo />
                </Box>

                <Box>
                    <IconButton onClick={handleMenuOpen}>
                        <Avatar sx={{ bgcolor: 'grey.500', width: 40, height: 40 }}>
                            {user?.avatar || user?.profilePicture ? (
                                <img
                                    src={user.avatar || user.profilePicture}
                                    alt={getDisplayName()}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            ) : (
                                getInitials(getDisplayName())
                            )}
                        </Avatar>
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <Box px={2} py={1}>
                            <Typography fontWeight={500}>
                                {getDisplayName()}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {getEmail()}
                            </Typography>
                        </Box>
                        <Divider />
                        <MenuItem onClick={handleLogout}>
                            <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                            Sair
                        </MenuItem>
                    </Menu>
                </Box>
            </StyledToolbar>
        </MuiAppBar>
    )
}

export { MyAppBar as AppBar }